/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_Not_ConnectedInputs */

const en_zotero_browser_not_connected = /** @type {(inputs: Zotero_Browser_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Zotero in Settings to import documents.`)
};

const es_zotero_browser_not_connected = /** @type {(inputs: Zotero_Browser_Not_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conecta Zotero en Ajustes para importar documentos.`)
};

/**
* | output |
* | --- |
* | "Connect Zotero in Settings to import documents." |
*
* @param {Zotero_Browser_Not_ConnectedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_not_connected = /** @type {((inputs?: Zotero_Browser_Not_ConnectedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Not_ConnectedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_not_connected(inputs)
	return en_zotero_browser_not_connected(inputs)
});